export const UNEDITABLE_CATEGORIES = ["Default", "Refund"];

export const CATEGORY_CONSTANT = {
  DEFAULT: "Default",
  REFUND: "Refund",
};
